module.exports = __webpack_public_path__ + "static/media/sidebar-analytic-selected.e0af59af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-analytic-selected.svg
// module id = 808
// module chunks = 0